import { create } from 'zustand';
export type Capability = 'client' | 'provider' | 'resource';
const storageKey = (organizationID: string) => `yingbaba.capability.${organizationID}`;
export function preferredCapability(organizationID: string, allowed: string[]): Capability {
  let saved: string | null = null;
  try {
    if (typeof window !== 'undefined')
      saved = window.localStorage.getItem(storageKey(organizationID));
  } catch {
    // Browsers with disabled storage still have a usable in-memory view.
  }
  if (saved && allowed.includes(saved) && ['client', 'provider', 'resource'].includes(saved))
    return saved as Capability;
  return allowed.includes('provider')
    ? 'provider'
    : allowed.includes('resource')
      ? 'resource'
      : 'client';
}
export const useWorkspaceUI = create<{
  capability: Capability;
  setCapability: (v: Capability, organizationID?: string) => void;
  mobileOpen: boolean;
  setMobileOpen: (v: boolean) => void;
}>((set) => ({
  capability: 'client',
  setCapability: (capability, organizationID) => {
    try {
      if (organizationID && typeof window !== 'undefined')
        window.localStorage.setItem(storageKey(organizationID), capability);
    } catch {
      // Retain the selected view for this page even when storage is unavailable.
    }
    set({ capability });
  },
  mobileOpen: false,
  setMobileOpen: (mobileOpen) => set({ mobileOpen }),
}));
